import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-house-02-Stroke',
  standalone: true,
  templateUrl: '../../assets/house-02/Stroke.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamHouse02StrokeIcon {}
